import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/articles/search';

export default {
  search(succ, searchQuery) {
    axios.get(INDEX_URL, { params: { search_phrase: searchQuery } })
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/search.js